import BaseModelAPI from '../BaseModelAPI';

export default class SubcontractRequestDeliveryList extends BaseModelAPI {

	static entity = 'newobject1952list'
	static entityName = 'subcontractrequestdelivery';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
